module.exports = __webpack_public_path__ + "assets/tenbisCredit-3fd6da.svg";